import * as React from 'react';
import {
  FontIcon,
  Stack,
  IStackTokens,
  Label,
  IDropdownOption,
  IconButton,
  IIconStyles,
} from '@fluentui/react';
import '../dashboard/CustomFilter.css';
import { sortBy, filter, indexOf } from 'lodash-es';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { BlockerColumn } from '../Models/BlockerColumns';
import { DraggableArea } from '../draggable-tags/index';

import { UATConstants } from '../Common/Models/UATConstants';

import { DisplayColumn, DisplayColumns } from '../Models/DisplayColumns';
import { SearchComponent } from '../dashboard/SearchComponent';
import { AnalyticsField, AnalyticsFieldColumnOptionTag } from './AnalyticsModel';

export interface ColumnOptionsProps {
  avFields: AnalyticsField[];
  onAddColumnOptions?: Function;
  fieldValues: string[];
}

export interface ColumnOptionsState {
  showSpinner: boolean;
  columns: AnalyticsField[];
  columnOptions: IDropdownOption[];
  selectedColumn: string[];
  tags: AnalyticsFieldColumnOptionTag[];
  originalTags: AnalyticsFieldColumnOptionTag[];
  selectedColumnsText: string[];
}

const navIconProps: Partial<IIconStyles> = {
  root: {
    fontSize: '17px',
    color: '#FFFFFF',
    backgroundColor: '#0078d4',
    width: 28,
    height: 24,
    paddingTop: 7,
  },
};
export class FieldColumnOptions extends React.Component<ColumnOptionsProps, ColumnOptionsState> {
  private ref: any;
  constructor(props: any) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      showSpinner: false,
      columns: [],
      columnOptions: [],
      selectedColumn: [],
      tags: [],
      originalTags: [],
      selectedColumnsText: [],
    };
  }

  componentDidMount() {
    this.handleClickAdd = this.handleClickAdd.bind(this);
    this.initFields(this.props.avFields);
  }

  componentWillUnmount(): void {
    this.props.onAddColumnOptions?.({
      selectedColumn: this.state.selectedColumn,
      tags: this.state.tags,
    });
  }

  private initFields = (allAVFields: AnalyticsField[]) => {
    this.getADOFields(allAVFields);
    this.getSelectedColumns(allAVFields);
  };

  private getADOFields = (displayColumns: AnalyticsField[]) => {
    this.setState({ showSpinner: true });

    const options: IDropdownOption[] = [];
    const selectedValues: string[] = [];
    const selectedColumns: string[] = [];

    displayColumns = sortBy(displayColumns, (g) => g.displayName);
    displayColumns = filter(displayColumns, (column: AnalyticsField) => {
      return (
        indexOf(
          UATConstants.DefaultAnalyticsViewColumnOptions.map((g) => g.internalName),
          column.propertyName
        ) === -1
      );
    });
    displayColumns.forEach((item: AnalyticsField) => {
      options.push({
        key: item.propertyName,
        text: item.displayName,
      });
    });

    this.setState({
      showSpinner: false,
      columnOptions: options,
      columns: displayColumns,
      selectedColumn: selectedColumns,
      selectedColumnsText: selectedValues,
    });
  };

  private getSelectedColumns(allFields: AnalyticsField[]) {
    const tags = [...this.state.tags];

    //Default columns
    UATConstants.DefaultAnalyticsViewColumnOptions.forEach((item: DisplayColumn) => {
      if (item.isDefault) {
        tags.push({
          name: item.displayName,
          id: item.internalName,
          isDefault: item.isDefault,
          internalName: item.internalName,
        });
      }
    });
    if (this.props.fieldValues.length === 0) {
      UATConstants.DefaultAnalyticsViewColumnOptions.forEach((item: DisplayColumn) => {
        if (!item.isDefault) {
          tags.push({
            name: item.displayName,
            id: item.internalName,
            isDefault: item.isDefault,
            internalName: item.internalName,
          });
        }
      });
    }

    //Existing fields (selected)
    this.props.fieldValues?.forEach((item: string) => {
      const obj = allFields.find((_item) => {
        return item == _item.propertyName;
      });
      if (
        obj !== undefined &&
        obj.propertyName !== 'Title' &&
        obj.propertyName !== 'WorkItemId' &&
        obj.propertyName !== 'Custom_Account'
      ) {
        tags.push({
          name: (item = obj === undefined ? '' : obj.displayName),
          id: item,
          isDefault: false,
          internalName: obj.propertyName,
        });
      }
    });

    const selectedColumns: string[] = [];
    const selectedValues: string[] = [];

    tags?.forEach((item: AnalyticsFieldColumnOptionTag) => {
      selectedColumns.push(item.internalName);
      selectedValues.push(item.name);
    });

    this.setState({
      selectedColumn: selectedColumns,
      selectedColumnsText: selectedValues,
      tags: tags,
      originalTags: tags,
    });
  }

  private handleClickAdd(option: string[]) {
    const selectedOptions = this.state.columnOptions.filter((item) => option.includes(item.text));

    let tags = [...this.state.tags];
    let selectedKeys = [...this.state.selectedColumn];
    const selectedValues = [...this.state.selectedColumnsText];

    selectedOptions.forEach((item) => {
      const obj = tags.find((_item) => {
        return item.key == _item.internalName;
      });
      if (obj === undefined) {
        tags.push({
          name: item.text,
          id: item.key.toString(),
          isDefault: false,
          internalName: item.key.toString(),
        });
        selectedKeys.push(item.key.toString());
      }
    });

    const removeItems: string[] = [];
    tags.forEach((item) => {
      const objInSelected = selectedOptions.find((_item) => {
        return item.internalName === _item.key;
      });
      if (objInSelected === undefined) {
        //find if not in default columns
        const objInDefault = UATConstants.DefaultAnalyticsViewColumnOptions.find((_item) => {
          return item.internalName === _item.internalName;
        });
        if (objInDefault === undefined) {
          removeItems.push(item.internalName);
        }
      }
    });
    removeItems.forEach((ritem) => {
      tags = tags.filter((item) => item.internalName !== ritem);
      selectedKeys = selectedKeys.filter((item) => item !== ritem);
    });

    this.setState({
      selectedColumn: selectedKeys,
      selectedColumnsText: selectedValues,
      tags: tags,
    });

    //Send to Parent component
    this.props.onAddColumnOptions?.({
      selectedColumn: selectedKeys,
      tags: tags,
    });
  }

  private BtnResetColumnOptions = () => {
    const tags = [];
    const SelectedKeys = [];
    for (let i = 0; i < this.state.tags.length; i++) {
      if (this.state.tags[i].isDefault) {
        SelectedKeys.push(this.state.tags[i].id);
        tags.push(this.state.tags[i]);
      }
    }
    this.setState({
      tags: tags,
      selectedColumn: SelectedKeys,
      selectedColumnsText: [],
    });
  };

  private handleClickDelete(tag: AnalyticsFieldColumnOptionTag) {
    const curTags = this.state.tags.filter((t) => tag.internalName !== t.internalName);
    let selectedKeys = [...this.state.selectedColumn];
    let selectedValues = [...this.state.selectedColumnsText];
    const dropdownOption = this.state.columnOptions.filter((op) => op.text === tag.name).pop();
    selectedKeys = selectedKeys.filter((key) => key !== tag.internalName);
    selectedValues = selectedValues.filter((value) => value !== tag.name);

    this.setState({
      selectedColumn: selectedKeys,
      tags: curTags,
      selectedColumnsText: selectedValues,
    });

    //Send to Parent component
    this.props.onAddColumnOptions?.({
      selectedColumn: selectedKeys,
      tags: curTags,
    });
  }

  render() {
    const containerStackTokens: IStackTokens = { childrenGap: 15 };

    return (
      <div className='customFilterContainer'>
        <div>
          {this.state.showSpinner && (
            <Spinner
              size={SpinnerSize.large}
              label={UATConstants.PlaceholdersAndTitles.Loading}
              ariaLive='assertive'
              className='loading-panel-full'
            />
          )}
        </div>

        <div className='ms-Grid paddingBottom50' dir='ltr'>
          <div className='height15'></div>
          <Stack tokens={containerStackTokens}>
            <div className='ms-Grid-row'>
              <div className='ms-Grid-col ms-lg10'>
                {UATConstants.PlaceholdersAndTitles.CustomizeFieldSelection}
                <br></br>
                {UATConstants.PlaceholdersAndTitles.AddUpdateRemoveView}
              </div>
            </div>

            <div className='ms-Grid-row'>
              <div className='ms-Grid-col ms-lg10'>
                <Label title={UATConstants.PlaceholdersAndTitles.SelectColumn}>
                  {UATConstants.PlaceholdersAndTitles.Fields}
                </Label>
              </div>

              <div
                className='ms-Grid-col ms-lg6 columnOptionsWrapper'
                aria-label={UATConstants.PlaceholdersAndTitles.ColumnOptions}>
                <SearchComponent
                  selectedItems={this.state.selectedColumnsText}
                  dropdownOptions={this.state.columnOptions}
                  placeholder={UATConstants.PlaceholdersAndTitles.SelectColumns}
                  label={UATConstants.PlaceholdersAndTitles.ColumnOptions}
                  disabled={false}
                  onChangeCallBack={this.handleClickAdd}
                  searchable
                />
              </div>
              <div className='ms-Grid-col ms-lg2'>
                <IconButton
                  title={UATConstants.PlaceholdersAndTitles.ResetColumnOptions}
                  onClick={this.BtnResetColumnOptions}
                  tabIndex={0}
                  iconProps={{
                    iconName: 'ClearSelection',
                    styles: navIconProps,
                  }}
                  className='editViewBtn'
                />
              </div>
            </div>
            <div>
              {' '}
              <hr className='hrBar' />
            </div>
            <div className='tagMain mlr-0ipx'>
              <p>{UATConstants.PlaceholdersAndTitles.SelectedFields}</p>
              <div className='main'>
                <DraggableArea
                  className='draggableAreaZIndex'
                  tags={this.state.tags}
                  render={(tagCollection: any) => (
                    <div className='tag'>
                      {tagCollection.tag.name}
                      {!tagCollection.tag.isDefault && (
                        <button
                          className='column-reorder'
                          onClick={() => this.handleClickDelete(tagCollection.tag)}>
                          <FontIcon
                            iconName={UATConstants.PlaceholdersAndTitles.StatusErrorFull}
                            className='deleteIcon'
                          />
                        </button>
                      )}
                    </div>
                  )}
                  onChange={(tags: any) => {
                    this.setState({ tags: tags });
                  }}
                />
              </div>
            </div>
          </Stack>
        </div>
      </div>
    );
  }
}
